<template>
    <div id="ContainerFormsConfigurationList">
        <div class="row">
            <div class="col-12">
                <h4 class="page-title text-truncate">
                    {{ $t('formsConfigurationList.Title') }}
                </h4>
                <div class="row">
                    <div class="col-sm-12 col-md-3" v-if="hasPermissionAdd()">
                        <MdButton
                            v-bind:Label="$t('Shared.Add')"
                            v-bind:ClassProp="'btn btn-primary my-3 btn-block btn-login'"
                            v-bind:IconClass="'ti-plus pr-1'"
                            v-on:click="AddNotification"
                            v-bind:Name="'btn_add_notification'"
                        >
                        </MdButton>
                    </div>
                    <div
                        v-bind:class="
                            hasPermissionAdd()
                                ? 'col-sm-12 col-md-9 mb-4'
                                : 'col-sm-12 col-md-12 mb-4'
                        "
                    >
                        <div class="textlabel" :data-label="this.$t('Shared.SearchElements')">
                            <div class="input-group" dir="ltr">
                                <input
                                    type="text"
                                    class="form-control"
                                    :dir="dirInput"
                                    v-model="parameter.SearchCriteria"
                                    @keyup.enter="SearchScreen"
                                />
                                <div class="input-group-append">
                                    <div class="input-group-append">
                                        <MdButton
                                            v-bind:Name="'btnsearchinput'"
                                            v-bind:VariantProp="'btn btn-sm search-attached'"
                                            v-bind:IconClass="'mdi mdi-magnify'"
                                            v-on:click="SearchScreen"
                                        >
                                        </MdButton>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-12 mt-2">
                <MdTitle
                    v-bind:Text="$t('Shared.SearchResult')"
                    v-bind:isSubtitle="true"
                    v-bind:Name="'T_TitleSearch'"
                />
                <div class="row">
                    <div class="col-md-12">
                        <MdTable
                            v-bind:fields="fields"
                            v-bind:items="items"
                            v-bind:totalRows="totalRows"
                            v-bind:isReadOnly="isReadOnly"
                            v-bind:showMessageIsEmpty="showMessageIsEmpty"
                            v-bind:currentPage="currentPage"
                            v-bind:perPage="perPage"
                            v-bind:pageOptions="pageOptions"
                            :onRowSelected="onRowSelected"
                            :onFiltered="onFiltered"
                            :pageChanged="pageChanged"
                            :perPageFunction="perPageFunction"
                            :viewIconEvent="handleViewEvent"
                        >
                        </MdTable>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import ScreensService from '@/services/screens.service';
import ShowMessage from '@/components/messages/ShowMessage.js';
import DBFunctions from '@/common/DBFunctions.js';
import Permission from '@/common/Permission';

export default {
    mixins: [ShowMessage, DBFunctions, Permission],
    name: 'FORMSCOFIGURATIONLIST',
    data() {
        return {
            OptionsRightMenu: {
                visible: false,
                ItemsList: [],
                btnvisible: false,
                itemdisabled: false,
                favButtonAtion: false
            },
            showMessageIsEmpty: false,
            Loading: true,
            parameter: {
                SearchCriteria: '',
                PageNumber: 0,
                PageSize: 0,
            },
            fields: [
                { key: 'recId', sortable: false, label: this.$t('Shared.Code'), class: 'hidden' },
                { key: 'screenName', sortable: true, label: this.$t('formsConfigurationList.Listing.eScreenName'), class: 'text-rigth' },
                { key: 'screenKey', sortable: true, label: this.$t('formsConfigurationList.Listing.eScreenKey'), class: 'text-rigth' },
                { key: 'screenDescription', sortable: true, label: this.$t('formsConfigurationList.Listing.eScreenDescription'), class: 'text-rigth'}
            ],
            pageOptions: [5, 10, 15],
            totalRows: 0,
            currentPage: 1,
            perPage: 10,
            filter: null,
            filterOn: [],
            items: [],
            selected: [],
            Header: {},
            isReadOnly: false,
            destination: [],
            dirInput: this.$i18n.locale === 'ar' ? 'rtl' : 'ltr'
        };
    },

    methods: {
        SearchScreen() {
            this.items = [];
            this.currentPage = 1;
            this.parameter.PageNumber = 1;
            this.totalRows = this.items.length;
            this.getFormsConfiguration();
        },

        handleViewEvent(row) {
            this.$router.push({ name: 'formsconfiguration-details', params: { id: row.recId } });
        },

        getFormsConfiguration() {
            this.parameter.PageNumber = this.currentPage;
            this.parameter.PageSize = this.perPage;
            ScreensService.getAll(this.parameter)
                .then(response => {
                    if (response.status == '200' && response.data) {
                        this.items = response.data;
                        let headerString = response.headers['x-pagination'];
                        this.totalRows = JSON.parse(headerString).TotalCount;
                    }
                })
                .catch(error => {
                    this.showResponseErrorMessage(error);
                });
        },

        pageChanged(page) {
            this.currentPage = page;
            this.getFormsConfiguration();
        },

        perPageFunction(perpage) {
            this.perPage = perpage;
            this.currentPage = 1;
            this.getFormsConfiguration();
        },

        onRowSelected(items) {
            this.selected = items;
        },

        selectAllRows() {
            this.$refs.selectableTable.selectAllRows();
        },

        clearSelected() {
            this.$refs.selectableTable.clearSelected();
        },

        selectThirdRow() {
            this.$refs.selectableTable.selectRow(2);
        },

        unselectThirdRow() {
            this.$refs.selectableTable.unselectRow(2);
        },

        onFiltered(filteredItems) {
            this.totalRows = filteredItems.length;
            this.currentPage = 1;
        }
    },

    mounted() {
        this.OptionsRightMenu.ItemsList = [];
        let layoutStatus = this.$store.state.layoutStatus;
        switch (layoutStatus) {
            case 'L0R1':
                this.OptionsRightMenu.favButtonAtion = false;
                this.$emit('getVisibleMenu', this.OptionsRightMenu);
                break;
            case 'L1R0':
            case 'L1R1':
                this.OptionsRightMenu.btnvisible = false;
                this.$emit('getVisibleMenu', this.OptionsRightMenu);
                break;
            default:
                this.OptionsRightMenu.favButtonAtion = false;
                this.$emit('getVisibleMenu', this.OptionsRightMenu);
        }
        this.getFormsConfiguration();
    }
};
</script>
